import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { HttperrorhandlerService } from 'src/app/main/shared/http/httperrorhandler.service';
import { catchError } from 'rxjs/operators';
import { ProjConstants } from 'src/app/utils/proj.constant';
import { isEmptyField } from 'src/app/main/shared/stock-chart-module/stock-chart/stock-chart-shared/stock-chart-shared-services/stock-chart-util.service';
import { UtilsSharedModule } from 'src/app/main/shared/utils/utils/utils.module';
import { ConstantsModule } from 'src/app/main/shared/constants/constants.module';

@Injectable({
  providedIn: 'root'
})
export class ObservedRainfallDataService {

  constructor(
    private http: HttpClient,
    private errorHandler: HttperrorhandlerService,
    private utilsShared: UtilsSharedModule,
    private constants: ConstantsModule,


  ) { }

  getRFStationData(options: object): Observable<any>{
    return this.http.post < any >(environment.url.PLAY_URL + "rf/rfTrend" , options).pipe(
      catchError(this.errorHandler.handleError('Kpi data request',[]))
    );
  }

  getKpiData(options:object): Observable < any >{
    return this.http.post < any >(environment.url.OBSERVED_API_URL + "rf/aggregated" , options).pipe(
      catchError(this.errorHandler.handleError('Kpi data request',[]))
    );
  }

  post(postData): Observable<any> {
    let projURL = environment.url.OBSERVED_API_URL + "rf/aggregated";
    return this.http.post<any>(projURL , postData);
  }

  getHWAccuracyData(postData): Observable<any> {
    return this.http.post < any >(ProjConstants.OBSERVED_API_URL + "rf/aggregated" , postData).pipe(
      catchError(this.errorHandler.handleError('Kpi data request',[]))
    );
  }

  getPostDataForSensor(params) {
    let postData = {
      "sDate": params.sDate,
      "eDate": params.eDate,
      "pUUID": params.locuuid,
      "pType": params.loctype,
      "format": this.getFormat(params.format),
      "cType": "RAINFALL",
      "pEUUID": params.locuuid,
      "classification": [
        "ACTUAL"
      ],
      "src": params.src,
      "aggr": params.aggr,
      "includeAllLoc": true
    }

    return postData
  }

  getFormat(format) {
    if(format == 'yyyyMMdd') {
      return 'DAILY'
    } else if(format == 'yyyyMM') {
      return 'MONTHLY'
    } else if(format == 'yyyy') {
      return 'YEARLY'
    } else {
      return 'HOURLY'
    }
  }


  getConfigForFilters(){
    let filterConfig = {
      sourceList: {
        isVisible: true,
        label:'Source of Data'
      },
      viewList: {
        isVisible: true,
        label:'Location Hierarchy'
      },
      locationTypeList: {
        isVisible: true,
        label:'Location Level'
      },
      locationList: {
        isVisible: true,
        label:'Location'
      },
      sDate: {
        isVisible: true,
        label:'Start Date'
      },
      eDate: {
        isVisible: true,
        label:'Stop Date'
      },
    }
    return filterConfig;
  }


  setRainfallcolor(value) {

    let obj;
    if (parseFloat(value) >= 60) {
      obj = {'textcolor': '#ffffff', 'bgcolor': '#0099ff'}
    }
    else if (parseFloat(value) >= 20 && parseFloat(value) < 60) {
      obj = {'textcolor': '#5e594e', 'bgcolor': '#b9e5fb'}
    }
    else if (parseFloat(value) >= -19 && parseFloat(value) < 20) {
      obj = {'textcolor': '#5e594e', 'bgcolor': '#90ed7d'}
    }
    else if (parseFloat(value) < -19 && parseFloat(value) > -60) {
      obj = {'textcolor': '#5e594e', 'bgcolor': '#e9e910'}
    }
    else if (parseFloat(value) <= -60 && parseFloat(value) > -99) {
      obj = {'textcolor': '#ffffff', 'bgcolor': '#e80d0d'}
    }
    else if (parseFloat(value) == -100) {
      obj = {'textcolor': '#ffffff', 'bgcolor': '#b3b1b1'}
    }
    else {
      obj = {'textcolor': '#5e594e', 'bgcolor': '#ffffff'}
    }
    return obj;
  }

  deepClone(object:any): any {
    if (isEmptyField(object)) {
      return;
    }
    if (Array.isArray(object)) {
      return object.slice();
    }
    const cloneObj :any= {};
    const attributes = Object.keys(object);
    for (const attribute of attributes) {
      const property = object[attribute];

      if (typeof property === 'object') {
        cloneObj[attribute] = this.deepClone(property);
      } else {
        cloneObj[attribute] = property;
      }
    }
    return cloneObj;
  }

  getTitleForComponent(urlParams) {
    let title = null;
    if (urlParams['format'] != "HOURLY") {
      title = this.utilsShared.gettimestepbyformat(urlParams['format']) + ' ' +
        this.utilsShared.getaggregationtypedisplay(urlParams['aggr']) + " Rainfall Information From " +
        this.utilsShared.getDateInFormatFromModelDate(this.utilsShared.getStartAndEndDatesForType(urlParams['sDate'], urlParams['eDate'], urlParams['format'])['startDate'], 'dd-mmm-yyyy') +
        " To "
        + this.utilsShared.getDateInFormatFromModelDate(this.utilsShared.getLastDayForGivenModelDate(urlParams['eDate'], this.constants.SELECTED_COMPONENT_CORRESPONDING_DATA.MAX_DATE), 'dd-mmm-yyyy') +
        ' Using ' + urlParams['src'] + ' Data'
    } else {
      title = this.utilsShared.gettimestepbyformat(urlParams['format']) + ' ' +
        this.utilsShared.getaggregationtypedisplay(urlParams['aggr']) + " Rainfall Information From " +
        this.utilsShared.getSimpleDateAndTimeStringFor12hrs(urlParams['sDate']) +
        " To "
        + this.utilsShared.getSimpleDateAndTimeStringFor12hrs(urlParams['eDate']) +
        ' Using ' + urlParams['src'] + ' Data'
    }

    return title;
  }

  getallAssociatedChildType(parentType, childType, parentEntityUUID) {
    let locationUrl = ProjConstants.OBSERVED_API_URL + "locations/allChildLocationList/" + parentEntityUUID + "/" + parentType + "/" + childType;
    return this.http.get<any>(locationUrl);
  }

}
